"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidAccessKey = void 0;
const isValidAccessKey = (accountId, accessKey, publicKey, call) => {
    if (accessKey.public_key === publicKey)
        return true;
    const { permission } = accessKey.access_key;
    if (permission === "FullAccess") {
        return true;
    }
    if (call && permission.FunctionCall) {
        const { receiver_id: allowedReceiverId, method_names: allowedMethods } = permission.FunctionCall;
        if (allowedReceiverId === accountId && allowedMethods.includes("add_request_and_confirm")) {
            return true;
        }
        if (allowedReceiverId === call.receiverId) {
            if (call.actions.length !== 1)
                return false;
            return call.actions.every((action) => {
                if (action.type !== "FunctionCall")
                    return false;
                return ((!action.params.deposit || action.params.deposit.toString() === "0") &&
                    (allowedMethods.length === 0 || allowedMethods.includes(action.params.methodName)));
            });
        }
    }
    return false;
};
exports.isValidAccessKey = isValidAccessKey;
